import {createAction} from 'redux-actions';
import axios from 'axios';
import {apiUrl} from './config';

export const REPORT_TRANSACTIONS = 'REPORT_TRANSACTIONS'

export const reportTransactions = createAction(REPORT_TRANSACTIONS, () => {
  return axios.get(apiUrl + 'client/transactions/report')
    .then(function(res) {
      return res.data.data
    })
});
